import { CompanyTitledPage } from "../../TitledPage";

import { getHyphenedPostCode } from "../../../utils/utils";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import { yellow } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";
import {
  deleteCustomerInfo,
  deleteShopInfo,
  searchCustomerInfoList,
  searchShopInfoList,
} from "../../../http/api/CustomerAPI";
import DeleteShopDialog from "../../shop/DeleteShopDialog";
import DeleteCustomerDialog from "../DeleteCustomerDialog";

const infoTableCellSx = {
  fontSize: 18,
};

const getCustomerLocationState = (customerId) => ({ customerId });

const getShopLocationState = (customerId, shopId) => ({
  customerId: customerId,
  shopId: shopId,
});

// 取引先情報表
// props...data = 表のデータ
function CustomerInfoTable(props) {
  const { customer } = props;

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              取引先名
            </TableCell>
            <TableCell sx={infoTableCellSx}>{customer.customerName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>フリガナ</TableCell>
            <TableCell sx={infoTableCellSx}>
              {customer.customerNameFurigana}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>住所</TableCell>
            <TableCell sx={infoTableCellSx}>
              {getHyphenedPostCode("")}
              <br />
              {customer.address}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>TEL</TableCell>
            <TableCell sx={infoTableCellSx}>{customer.tel}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>FAX</TableCell>
            <TableCell sx={infoTableCellSx}>{customer.fax}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>Email</TableCell>
            <TableCell sx={infoTableCellSx}>{customer.email}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>買人No.</TableCell>
            <TableCell sx={infoTableCellSx}>{customer.buyerNo}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// 商品一覧表示
function CustomerShopLinkList(props) {
  if (props.shopList.length > 0) {
    return (
      <TableContainer component={Box}>
        <Table>
          <TableBody>
            {props.shopList.map((data, i) => (
              <TableRow key={i}>
                <TableCell sx={infoTableCellSx}>
                  <Grid container>
                    <Grid item xs>
                      <Link
                        to={SYSTEM_PATH_COMPANY + "/shop_information"}
                        state={getShopLocationState(
                          props.customerId,
                          data.shopId
                        )}
                      >
                        {data.shopName}
                      </Link>
                    </Grid>
                    <Grid item xs="auto">
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={props.onClickDeleteShop(data)}
                      >
                        削除
                      </Button>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return <Typography>店舗が登録されていません</Typography>;
}

// 取引先情報表示ページ
export default function CustomerInformationPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const customerId = location.state.customerId;
  const [customer, setCustomer] = useState({});
  const [shopList, setShopList] = useState([]);

  useEffect(() => {
    if (customerId != null) {
      GetCustomerInfo();
      GetShopInfoList();
    }
  }, []);

  //取引先情報を取得
  async function GetCustomerInfo() {
    let response = await searchCustomerInfoList({ customerId });
    setCustomer(response.listCustomerInfo[0]);
  }

  //店舗情報を取得
  async function GetShopInfoList() {
    let response = await searchShopInfoList({ customerId });
    setShopList(response.listShopInfo);
  }

  const [openDeleteShopDialog, setOpenDeleteShopDialog] = useState(false);
  const [selectedDeleteShop, setSelectedDeleteShop] = useState({});

  const [openDeleteCustomerDialog, setOpenDeleteCustomerDialog] =
    useState(false);

  // 取引先一覧画面に戻る
  const onClickReturnCustomerSearch = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_search");
  };

  // 取引先情報を編集
  const onClickEdit = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_information_edit", {
      state: getCustomerLocationState(customerId),
    });
  };

  // 取引先情報を削除
  const onClickDeleteCustomer = (event) => {
    setOpenDeleteCustomerDialog(true);
  };

  const onCloseDeleteCustomerDialog = (event) => {
    setOpenDeleteCustomerDialog(false);
  };

  // 店舗情報を登録
  const onClickShopRegistration = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/shop_registration", {
      state: getCustomerLocationState(customerId),
    });
  };

  const onClickShopGroupEdit = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/shop_group_edit", {
      state: getCustomerLocationState(customerId),
    });
  };

  const onClickDeleteShop = (shopData) => (event) => {
    setSelectedDeleteShop(shopData);
    setOpenDeleteShopDialog(true);
  };

  const onCloseDeleteShopDialog = (event) => {
    setOpenDeleteShopDialog(false);
  };

  //店舗を削除作業
  async function onDeleteShop() {
    //APIコールパラメータ
    let deleteParams = {
      shopId: selectedDeleteShop.shopId,
      updatedId: 2, //TODO JWTで判定する
    };
    try {
      //削除APIをコール
      await deleteShopInfo(deleteParams);

      //Stateのデータを削除する
      let newListShop = shopList.filter(
        (p) => p.shopId != selectedDeleteShop.shopId
      );
      setShopList(newListShop);
    } catch {
      alert(`店舗を削除できませんでした。`);
    }
  }

  //取引先を削除作業
  async function onDeleteCustomer() {
    //APIコールパラメータ
    let deleteParams = {
      customerId: customerId,
      updatedId: 2, //TODO JWTで判定する
    };
    try {
      //削除APIをコール
      await deleteCustomerInfo(deleteParams);
      
      //取引先一覧画面に遷移する
      navigate(SYSTEM_PATH_COMPANY + "/customer_search");
    } catch {
      alert(`取引先を削除できませんでした。`);
    }
  }

  return (
    <CompanyTitledPage title="取引先情報表示">
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography fontWeight="bold" fontSize={30}>
            {customer.customerName}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Button variant="outlined" onClick={onClickReturnCustomerSearch}>
            取引先検索に戻る
          </Button>
        </Grid>
      </Grid>

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              取引先基本情報
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickEdit}>
              編集
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              color="error"
              onClick={onClickDeleteCustomer}
            >
              取引先を削除
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <CustomerInfoTable customer={customer} />

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              店舗一覧
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickShopRegistration}>
              新規店舗登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              onClick={onClickShopGroupEdit}
              disabled={shopList.length === 0}
            >
              店舗グループ編集
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <CustomerShopLinkList
        customerId={customerId}
        shopList={shopList}
        onClickDeleteShop={onClickDeleteShop}
      />

      <DeleteCustomerDialog
        open={openDeleteCustomerDialog}
        onCloseDialog={onCloseDeleteCustomerDialog}
        customer={customer}
        deleteAction={onDeleteCustomer}
      />
      <DeleteShopDialog
        open={openDeleteShopDialog}
        onCloseDialog={onCloseDeleteShopDialog}
        shop={selectedDeleteShop}
        deleteAction={onDeleteShop}
      />
    </CompanyTitledPage>
  );
}
